import React from 'react';
import { Helmet } from 'react-helmet-async';

import { useTranslation } from 'app/lang';
import Footer from 'app/modules/Layout/Footer';
import ErrorBoundary from 'app/widgets/ErrorBoundary';

import Content from './ContentDeferred';

import dictionary from './Deposit.dictionary.json';

function DepositPage() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t(dictionary.title)}</title>
      </Helmet>

      <ErrorBoundary>
        <Content />
        <Footer />
      </ErrorBoundary>
    </>
  );
}

export default DepositPage;
